import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type { TriggerJobRequestActionPayload } from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';

const TriggerJob = new ReduxAsyncAction<'FILE_INGESTOR_TRIGGER_JOB', TriggerJobRequestActionPayload, void>(
  'FILE_INGESTOR_TRIGGER_JOB'
);

TriggerJob.registerRequest(async (payload) => {
  try {
    await dash_api.post<void>('/v1/roi/file-ingestor/trigger-job', payload);
  } catch (error) {
    NotificationActions.showNotification('Error occurred when triggering import job', 'error');
    throw error;
  }
});

export const TRIGGER_JOB = TriggerJob.actionNamespaceConstants;

export const triggerIngestionJob = TriggerJob.request;

export type TriggerJobResponseAction = Action<typeof TRIGGER_JOB.response>;
